import React from 'react';
import { useDolarBlue } from '../hooks/useDolarBlue';
import { DollarSign } from 'lucide-react';

const DolarIndicator = () => {
  const { cotizacion, loading, error } = useDolarBlue();

  if (loading) {
    return (
      <div className="flex items-center space-x-2 text-xs text-gray-500">
        <DollarSign className="w-3 h-3 " />
        <span>Cargando...</span>
      </div>
    );
  }

  if (error || !cotizacion) {
    return (
      <div className="flex items-center space-x-2 text-xs text-red-400">
        <DollarSign className="w-3 h-3" />
        <span>Error</span>
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-2 text-xs text-gray-400">
      <DollarSign className="w-3 h-3" />
      <span>Blue: ${cotizacion.venta}</span>
    </div>
  );
};

export default DolarIndicator;